export const ALLOW = 'allow';

export const DENY = 'deny';

export const ERROR = 'error';
